module.exports = __webpack_public_path__ + "img/clinic-image2.631eb2a.jpg";